(() => {
  const initGiftWrappingStore = () => {
    if (!window.Alpine) return;

    Alpine.store('xGiftWrapping', {
      loading: false,

      async add(productId) {
        if (this.loading) return;

        this.loading = true;
        await Alpine.store('xCartHelper').waitForCartUpdate();
        window.updatingCart = true;

        const items = [
          {
            id: productId,
            quantity: 1
          }
        ];

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          })
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 422) {
            console.error('Erro ao adicionar embalagem para presente:', response.description || response.message);
            return;
          }

          Alpine.store('xCartHelper').reRenderSections(response.sections);

          const cartBubble = document.querySelector('#cart-icon-bubble span');
          if (cartBubble) {
            Alpine.store('xCartHelper').currentItemCount = parseInt(cartBubble.innerHTML);
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        })
        .catch((error) => {
          console.error('Erro ao adicionar embalagem para presente:', error);
        })
        .finally(() => {
          window.updatingCart = false;
          this.loading = false;
        });
      }
    });
  };

  if (window.Alpine) {
    initGiftWrappingStore();
  } else {
    document.addEventListener('alpine:init', initGiftWrappingStore);
  }
})();